import { ObservableFromFetch } from "../ObservableFromFetch"
import PoolGridData from "./RandomsModel/PoolGridData"
import FormatDate from "../../formatters/FormatDate"
import { Filter, Sort } from "../GridRequest"

export function PoolGridGetObservable(pageNumber: number, pageSize: number, sort: Sort, filters: Filter[], search: { field: string, text: string }, isConsortium: boolean = false) {
  const requestBody: string = JSON.stringify({
    BatchPool: "",
    BySel: search.field,
    Filters: {
      ID: filters.find(filter => filter.column === "ID")?.values || [],
      Name: filters.find(filter => filter.column === "Name")?.values || [],
      LastMemberImport: filters.find(filter => filter.column === "LastUpdate")?.values.map((value) => FormatDate(value)) || [],
      LastSelection: filters.find(filter => filter.column === "LastSelection")?.values || [],
      ReadyToRun: filters.find(filter => filter.column === "ReadyToRunDate")?.values || [],       // NOTE: this mapping matches 1.0
      ReadyToRunDate: [],//filters.find(filter => filter.column === "ReadyToRunDate")?.values || [],
      SelectionInterval: filters.find(filter => filter.column === "SelectionInterval")?.values || [],
    },
    MatchSel: "Partial",
    PageNumber: pageNumber,
    PageSize: pageSize,
    SortGrid: { SortColumn: sort.column, SortOrder: sort.order.toUpperCase() === "DESC" ? "DSC" : sort.order.toUpperCase() },
    SrchFor: search.text,
    TypeSel: "",
    IsConsortium: isConsortium
  })

  return ObservableFromFetch<PoolGridData>("RandomTest/GetPoolGrid", requestBody)
}

export function PoolGridCsvGet(filters: Filter[], search: { field: string, text: string }, isConsortium: boolean = false) {
  const requestBody: string = JSON.stringify({
    BatchPool: "",
    BySel: search.field,
    Filters: {
      // Next 4 filters always empty in 1.0: in code we pass array but the array is never filled up
      // 1.0 code: src\app\pages\random-testing-pools\random-testing-pools.component.ts, method "exportCSV":
      // this.printMemberObj['Filters'].LastMemberImport = lastUpdateArray;
      // this.printMemberObj['Filters'].LastSelection = this.selectedLastselectionsList;
      // this.printMemberObj['Filters'].ReadyToRun = this.selectedReadytorunList;
      // this.printMemberObj['Filters'].SelectionInterval = this.selectedIntervalList;
      LastMemberImport: [],
      LastSelection: [],
      ReadyToRun: [],
      SelectionInterval: []
    },
    MatchSel: "Partial",
    SrchFor: search.text,
    TypeSel: "",
    IsConsortium: isConsortium
  })

  return ObservableFromFetch<string>("RandomTest/ExportRandomRecords", requestBody)
}

export function PoolGridPrint(values: number[], filters: { column: string, values: string[] }[], search: { field: string, text: string }, isConsortium: boolean = false) {
  const requestBody: string = JSON.stringify({
    ContactID: 0, // TODO: VALUESTORAGE.CONTACT_ID Verify parameter value
    PoolID: values,
    BatchPool: "",
    BySel: search.field ? search.field : "All",
    Filters: {
      // Next 4 filters always empty in 1.0: in code we pass array but the array is never filled up
      // 1.0 code: src\app\pages\random-testing-pools\random-testing-pools.component.ts, method "actualPrintFunction":
      // this.printMemberObj['Filters'].LastMemberImport = lastUpdateArray;
      // this.printMemberObj['Filters'].LastSelection = this.selectedLastselectionsList;
      // this.printMemberObj['Filters'].ReadyToRun = this.selectedReadytorunList;
      // this.printMemberObj['Filters'].SelectionInterval = this.selectedIntervalList;
      LastMemberImport: [],
      LastSelection: [],
      ReadyToRun: [],
      SelectionInterval: [],
      // Next 3 filters always empty in 1.0 - pass them empty too
      ReadyToRunDate: [],
      ID: [],
      Name: [],
    },
    MatchSel: "Partial",
    SrchFor: search.text,
    TypeSel: "",
    IsConsortium: isConsortium
  })
  return ObservableFromFetch<string>("WorkforceRandomTest/PrintRandomRecords", requestBody)
}
